import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { ProFormDatePicker } from '@ant-design/pro-form';
import { message } from 'antd';
import moment from 'moment';
import {
  GET_PROJECT_APPLICATION,
  SUBMIT_PROJECT_APPLICATION,
} from 'gql/projectApplications';
import { ProForm } from 'components/layout';

import ApplicationDetail from './ApplicationDetail';

const SubmitProjectApplication = ({ reducer: { dispatch } }) => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION, {
    variables: { id: id },
  });
  const [submitProjectApplication] = useMutation(SUBMIT_PROJECT_APPLICATION, {
    refetchQueries: [{ query: GET_PROJECT_APPLICATION, variables: { id: id } }],
  });
  const onFinish = async () => {
    await submitProjectApplication({
      variables: {
        id,
      },
    });
    message.success('Application submitted successfully');
  };

  return (
    <>
      <ApplicationDetail data={data?.projectApplication} loading={loading} />
      <ProForm
        requiredMark={false}
        initialValues={{ date: moment().format('YYYY-MM-DD') }}
        onFinish={onFinish}
        onReset={() => dispatch({ type: 'APPLY' })}
      >
        <ProFormDatePicker
          label="Application Date"
          name="date"
          width="xl"
          disabled={true}
        />
      </ProForm>
    </>
  );
};

export default SubmitProjectApplication;
